<template functional>
  <label
    class="tracking-wider text-gray-800"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data)"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <slot>
      {{ props.text }}
    </slot>
  </label>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  name: 'MiaCarEditFeatureLabel',

  props: {
    text: {
      type: String,
      default: ''
    }
  },

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
